import { api } from './client'

export type ClientType = 'individual' | 'company' | 'llp' | 'partnership'

export interface Client {
  id: string
  firm_id: string
  name: string
  client_type: ClientType
  gstin?: string | null
  tan?: string | null
  pan?: string | null
  email?: string | null
  phone?: string | null
  extra_data: Record<string, unknown>
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface ClientListResponse {
  items: Client[]
  total: number
  page: number
  per_page: number
}

export interface ClientFilters {
  search?: string
  client_type?: ClientType
  is_active?: boolean
  page?: number
  per_page?: number
}

export const clientsApi = {
  /**
   * List clients with optional filters
   */
  list: (filters?: ClientFilters): Promise<ClientListResponse> => {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, String(value))
        }
      })
    }
    const query = params.toString()
    return api.get(`/api/v1/clients${query ? `?${query}` : ''}`)
  },

  /**
   * Get a single client by ID
   */
  get: (id: string): Promise<Client> => {
    return api.get(`/api/v1/clients/${id}`)
  },
}
